import React from "react";
import {deleteVariableCust, getVariableCusts, saveVariableCust, updateVariableCust} from "../../services/variableCustsService"; // ajuste o caminho
import { useCompany } from "../../contexts/CompanyContext";
import CrudTable from "../../components/Custom/CrudTable";
import { Autocomplete, TextField } from "@mui/material";

import { opcoesCustosVariaveis } from '../../constants/opcoesCustos';

const VariableCostList = () => {
  const { company } = useCompany();
  
  const columns = [
    { key: "descricao", label: "Descrição" },
    { key: "valor", label: "Valor" , render: (v) => `R$ ${parseFloat(v).toFixed(2)}`}
  ];

  const fields = [
    { name: "descricao", label: "Descrição" },
    { name: "valor", label: "Valor", type: "number" }
  ];

  const service = {
    getAll: (companyId) => getVariableCusts(companyId),
    create: (companyId, data) => saveVariableCust(companyId, data),
    update: (companyId, id, data) => updateVariableCust(companyId, id, data),
    remove: (companyId, id) => deleteVariableCust(companyId, id),
  };

const renderForm = (item, handleChange, setItem) => (
    <>
      <Autocomplete
        size="small"
        freeSolo
        options={opcoesCustosVariaveis}
        value={item.descricao || ""}
        sx={{ width: "100%", mt: 1 }}
        onInputChange={(e, newValue) => setItem({ ...item, descricao: newValue })}
        renderInput={(params) => <TextField {...params} label="Descrição" fullWidth />}
      />

      <TextField
        fullWidth
        margin="normal"
        type="number"
        label="Valor"
        name="valor"
        value={item.valor || ""}
        onChange={handleChange}
      />
    </>
  );

  return (
    <CrudTable
      title="Costos Variáveis"
      columns={columns}
      fields={fields}              
      service={service}
      entityName="Costo Variável"
      companyId={company.companyId}
      renderForm={renderForm}      
    />
  );
};

export default VariableCostList;
